import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-781d8c0a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-margin"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_van_button = _resolveComponent("van-button");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    footer: _withCtx(() => [_createVNode(_component_van_button, {
      plain: "",
      icon: "plus",
      style: {
        "width": "100%"
      },
      type: "primary",
      onClick: $setup.onToEditor
    }, {
      default: _withCtx(() => [_createTextVNode(" 添加联系地址 ")]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
      ref: "listViewCptRef",
      requestParameter: $setup.searchForm,
      request: $setup.listRequest,
      isPaging: false,
      resultDataFormatter: $setup.resultDataFormatter
    }, {
      default: _withCtx(({
        item
      }) => [_hoisted_1, _createVNode(_component_van_cell, {
        title: $setup.formatSelectColumn($setup.codeResItems, 'addressType', {
          addressType: item.addressType
        }),
        "is-link": "",
        "arrow-direction": "",
        to: '/wx/addr?item=' + JSON.stringify(item)
      }, {
        label: _withCtx(() => [_createElementVNode("div", null, _toDisplayString((item.pcc || '') + (item.street || '')), 1)]),
        _: 2
      }, 1032, ["title", "to"])]),
      _: 1
    }, 8, ["requestParameter", "request", "resultDataFormatter"])]),
    _: 1
  });
}